module.exports = __webpack_public_path__ + "static/media/book-cover.e99c69b1.png";